import {
  CardInfoWrapper,
  ProfileImg,
  Name,
  Title,
  Email,
  Message,
  Company,
  DarkBackGround,
  Wrapper,
  CloseButton,
  DownloadButton,
  FixedCardWrapper,
} from "./style";
import { useRef } from "react";
import domtoimage from "dom-to-image";
import { saveAs } from "file-saver";

const DEAFULT_IMAGE = `${process.env.PUBLIC_URL}/images/default.jpg`;

const CardModal = (props) => {
  const { data, setIsOpen } = props;
  const { name, company, title, email, message, theme, filePath } = data;
  const imgPath = filePath || DEAFULT_IMAGE;

  const cardRef = useRef();

  const handleDownload = async (event) => {
    event.stopPropagation(); // 이벤트 버블링 막기
    const blob = await domtoimage.toBlob(cardRef.current);
    saveAs(blob, `${name}_card.png`);
  };

  return (
    <DarkBackGround onClick={() => setIsOpen(false)}>
      <Wrapper>
        <CloseButton>X</CloseButton>

        <FixedCardWrapper ref={cardRef} cardTheme={theme}>
          <ProfileImg src={imgPath} alt="profile" />
          <CardInfoWrapper>
            <Name>{name}</Name>
            <Company>{company}</Company>
            <hr />
            <Title>{title}</Title>
            <Email>{email}</Email>
            <Message>{message}</Message>
          </CardInfoWrapper>
        </FixedCardWrapper>
        <DownloadButton onClick={handleDownload}>다운로드</DownloadButton>
      </Wrapper>
    </DarkBackGround>
  );
};

export default CardModal;
